var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.image)?_c('v-img',{attrs:{"contain":"","eager":"","src":_vm.image}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }